import { getIdToken } from './firebase';
import { kwApiUrl } from '../config/kwApi';

/**
 * @returns {Promise<Record<string, unknown> | null>}
 */
export async function fetchSubscriptionDetails(lang = 'en') {
  const token = await getIdToken();
  if (!token) {
    return null;
  }

  const url = kwApiUrl('subscription/details');

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ lang }),
    });

    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('text/html')) {
      console.error('subscription/details returned HTML — check VITE_KW_API_PATH / proxy');
      return null;
    }

    const json = await response.json().catch(() => ({}));
    if (!response.ok || json?.result !== 'success') {
      console.error('subscription/details failed', response.status, json);
      return null;
    }

    return json.data && typeof json.data === 'object' ? json.data : null;
  } catch (error) {
    console.error('fetchSubscriptionDetails error:', error);
    return null;
  }
}
